import { useMemo } from "react";
import { resolveTransferLimits, type TransferLimits } from "../../packaging";

interface OptionalTransferLimits {
  maxFileCount: number | undefined;
  warnTotalBytes: number | undefined;
  hardMaxTotalBytes: number | undefined;
  warnEstimatedSeconds: number | undefined;
  maxChunkCount: number | undefined;
  maxMetadataBytes: number | undefined;
  maxFileNameLength: number | undefined;
  maxMimeTypeLength: number | undefined;
  maxExpandedBytes: number | undefined;
}

function resolveOptionalLimits(values: OptionalTransferLimits): TransferLimits {
  return resolveTransferLimits({
    ...(values.maxFileCount === undefined ? {} : { maxFileCount: values.maxFileCount }),
    ...(values.warnTotalBytes === undefined
      ? {}
      : { warnTotalBytes: values.warnTotalBytes }),
    ...(values.hardMaxTotalBytes === undefined
      ? {}
      : { hardMaxTotalBytes: values.hardMaxTotalBytes }),
    ...(values.warnEstimatedSeconds === undefined
      ? {}
      : { warnEstimatedSeconds: values.warnEstimatedSeconds }),
    ...(values.maxChunkCount === undefined
      ? {}
      : { maxChunkCount: values.maxChunkCount }),
    ...(values.maxMetadataBytes === undefined
      ? {}
      : { maxMetadataBytes: values.maxMetadataBytes }),
    ...(values.maxFileNameLength === undefined
      ? {}
      : { maxFileNameLength: values.maxFileNameLength }),
    ...(values.maxMimeTypeLength === undefined
      ? {}
      : { maxMimeTypeLength: values.maxMimeTypeLength }),
    ...(values.maxExpandedBytes === undefined
      ? {}
      : { maxExpandedBytes: values.maxExpandedBytes }),
  });
}

export function useTransferLimits(overrides: Partial<TransferLimits>): TransferLimits {
  const {
    maxFileCount,
    warnTotalBytes,
    hardMaxTotalBytes,
    warnEstimatedSeconds,
    maxChunkCount,
    maxMetadataBytes,
    maxFileNameLength,
    maxMimeTypeLength,
    maxExpandedBytes,
  } = overrides;

  return useMemo(
    () =>
      resolveOptionalLimits({
        maxFileCount,
        warnTotalBytes,
        hardMaxTotalBytes,
        warnEstimatedSeconds,
        maxChunkCount,
        maxMetadataBytes,
        maxFileNameLength,
        maxMimeTypeLength,
        maxExpandedBytes,
      }),
    [
      hardMaxTotalBytes,
      maxChunkCount,
      maxExpandedBytes,
      maxFileCount,
      maxFileNameLength,
      maxMetadataBytes,
      maxMimeTypeLength,
      warnEstimatedSeconds,
      warnTotalBytes,
    ],
  );
}
